import { useMemo } from "react"
import { get } from "lodash"
import useResource from "hooks/resources"
import { useAccountId } from "resources/account"
import { Uuid } from "helpers/types/uuid"
import { DataStatus, ResourceResult, LOADING, OK } from "helpers/data-statuses"

interface FavoriteResource {
  ["0"]: {
    value: {
      resourceId: string | Uuid
    }[]
  }
}

function useFavoriteResources(): ResourceResult<FavoriteResource> {
  const accountId = useAccountId()

  return useResource({
    resource: "userFavoriteResources",
    url: () => ({
      id: `userFavoriteResources-${accountId}`,
      url: "/api/users/me/preferences",
      payload: {
        items: [{ type: "favoriteResources", accountId }],
      },
    }),
  }, "userFavoriteResources")
}

export function useIsResourceFavorite(resourceId: string | Uuid | undefined): [boolean, DataStatus] {
  const [favoriteResourcesData, favoriteResourcesStatus] = useFavoriteResources()

  return useMemo(() => {
    if (!resourceId || favoriteResourcesStatus === LOADING) {
      return [false, favoriteResourcesStatus]
    }

    if (favoriteResourcesStatus !== OK) {
      return [false, favoriteResourcesStatus]
    }

    const favoriteResourcesList = get(favoriteResourcesData, "0.value", [])
    const isFavorite = favoriteResourcesList.some(item => item.resourceId === resourceId)
    return [isFavorite, OK]
  }, [resourceId, favoriteResourcesData, favoriteResourcesStatus])
}
